<template>
  <div class="mainbg">
    <mt-tab-container v-model="selected" class="maincontent">
      <mt-tab-container-item id="tab-container1">
        <ccenter v-on:message="recieveMessage"></ccenter>
      </mt-tab-container-item>
      <mt-tab-container-item id="tab-container2">
        <ccontract :contractstatus="contractstatus"></ccontract>
      </mt-tab-container-item>
      <mt-tab-container-item id="tab-container3">
        <cmy></cmy>
      </mt-tab-container-item>
    </mt-tab-container>

    <mt-tabbar :fixed="true" v-model="selected">
      <mt-tab-item id="tab-container1">
        <div v-if="selected=='tab-container1'">
          <img class="tabimg" src="/static/img/tabbar/tabbar1.png">
          <div>中心</div>
        </div>
        <div @click="saveSelectTab('tab-container1')" v-if="selected!='tab-container1'">
          <img class="tabimg" src="/static/img/tabbar/tabbar2.png">
          <div class="tabtitle">中心</div>
        </div>
      </mt-tab-item>
      <mt-tab-item id="tab-container2">
        <div v-if="selected=='tab-container2'">
          <img class="tabimg" src="/static/img/tabbar/tabbar3.png">
          <div>我的文件</div>
        </div>
        <div @click="saveSelectTab('tab-container2')" v-if="selected!='tab-container2'">
          <img class="tabimg" src="/static/img/tabbar/tabbar4.png">
          <div class="tabtitle">我的文件</div>
        </div>
      </mt-tab-item>
      <mt-tab-item id="tab-container3">
        <div v-if="selected=='tab-container3'">
          <img class="tabimg" src="/static/img/tabbar/tabbar5.png">
          <div>我的</div>
        </div>
        <div @click="saveSelectTab('tab-container3')" v-if="selected!='tab-container3'">
          <img class="tabimg" src="/static/img/tabbar/tabbar6.png">
          <div class="tabtitle">我的</div>
        </div>
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
  import cheader from '@/components/header';
  import ccontract from '@/module/contract/ContractList';
  import cmy from '@/module/my/My';
  import ccenter from '@/module/user/center';
  export default {
    data () {
      return {
        selected: "",
        contractstatus:"0"
      }
    },
    methods: {
      saveSelectTab(tabvalue) {
        localStorage.removeItem("tab-selected");
        localStorage.setItem("tab-selected", tabvalue);
        if(tabvalue == 'tab-container2'){
          localStorage.setItem("clist_status", '1');
          window.location.reload();
        }
      },
      goInput: function () {
        this.$router.push('/main/searchcontract');
      },
      recieveMessage: function (text) {
        this.contractstatus = text;
        this.selected = 'tab-container2';
        localStorage.setItem("tab-selected",'tab-container2');
      },
      valiateNull:function (pro) {
        if ( pro == "" ||  typeof(pro) == "undefined" || pro == null){
          return false;
        }else {
          return true
        }

      },
      approvalSync:function (params,sign) {
        this.$http.post(
          domain("_approvalSync"), {
            params:params,
            sign: sign
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            window.location.reload();
          }, function (error) {
          })
      },
      getUrlKey:function (name) {
        var reg = ( new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)|| ['']);
        if(this.valiateNull(reg[1])){
          return  decodeURIComponent(reg[1].replace(/\+/g,'%20'))|| null

        }else{
          return null;
        }

      }
    },
    components: {
      cheader,
      ccontract,
      cmy,
      ccenter
    },
    created: function () {
      this.selected = localStorage.getItem("tab-selected") || 'tab-container1';
      var params = this.getUrlKey('params');
      var sign =  this.getUrlKey('sign');
      if(this.valiateNull(params) && this.valiateNull(sign)){
        this.approvalSync(params,sign);
      }
    }
  }
</script>
<style>
  .mainbg {
    height: 100%;
  }

  .maincontent {
    min-height: 100%;
    background-color: #f0f0f0;
  }

  .tabtitle {
    font-size: 0.6rem;
    color: #7d7d7d;
  }

  .tabimg {
    margin: 2px 0;
    width: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/module/index/Main.vue